import * as React from "react";

// HeaderBridgeAnimation — the decorative SkillsBridge "bridge" that self-draws in the app header
// (source geometry: skillsbridgeasset · Bridge 2). This renders the SVG shape only; its colour, line
// self-draw and node styling live in HeaderBridgeStyled (LayoutV2.styles.js), which wraps it.
//
// Kept at TRUE proportions (preserveAspectRatio="meet", not stretched) and anchored to the LEFT so
// the line only occupies the left side of the header; the tall arch tops spill above (clipped).
const BRIDGE_PATH =
  "M0.554276 1034.97C85.7425 530.563 669.537 481.604 905.363 723.111C987.846 568.452 1273.93 458.433 1457.6 561.462C1542.21 404.859 1828.3 294.84 2011.97 397.869C2220.22 -56.6881 2722.72 -86.3583 3057.12 338.01";

// Real asset node positions (the arc vertices).
const NODES = [
  { cx: 905.817, cy: 726.629 },
  { cx: 1460.87, cy: 563.402 },
  { cx: 2013.32, cy: 400.377 },
];

const HeaderBridgeAnimation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 300 2800 560"
    fill="none"
    preserveAspectRatio="xMinYMid meet"
    {...props}
  >
    <path className="bridge-span" d={BRIDGE_PATH} pathLength="1" />

    {/* static node points — solid core + faint halo ring */}
    {NODES.map((n, i) => (
      <React.Fragment key={i}>
        <circle className="bridge-node-halo" cx={n.cx} cy={n.cy} r="48" />
        <circle className="bridge-node" cx={n.cx} cy={n.cy} r="22" />
      </React.Fragment>
    ))}
  </svg>
);

export default HeaderBridgeAnimation;
